import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-x', 'LetterX', [["path",{"d":"M7 4l10 16"}],["path",{"d":"M17 4l-10 16"}]]);